module.exports = __webpack_public_path__ + "static/media/6@1024w.902fa84a.jpg";